import {
  GET_MERCHANTS_RECURRING_FAILD,
  GET_MERCHANTS_RECURRING_LOADING,
  GET_MERCHANTS_RECURRING_SUCCESS,
  APPEND_MERCHANTS_RECURRING_SUCCESS,
  RESET_MERCHANT_RECURRING_LIST,
} from "../types";

const initialState: {
  loading: boolean;
  error: any;
  merchants: { content: any[]; last: boolean; [key: string]: any } | null;
} = {
  loading: false,
  error: null,
  merchants: null,
};

export const getMerchantsOfPartnersReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_MERCHANTS_RECURRING_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_MERCHANTS_RECURRING_SUCCESS:
      return {
        ...state,
        loading: false,
        merchants: action.payload,
        error: null,
      };
    case APPEND_MERCHANTS_RECURRING_SUCCESS: {
      const existingContent = state.merchants?.content ?? [];
      return {
        ...state,
        loading: false,
        merchants: {
          ...action.payload,
          content: [...existingContent, ...action.payload.content],
        },
        error: null,
      };
    }
    case GET_MERCHANTS_RECURRING_FAILD:
      return {
        ...state,
        loading: false,
        merchants: null,
        error: action.error,
      };
    case RESET_MERCHANT_RECURRING_LIST:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
